import { Typology } from '@bcef/ia-shared';

import { Civility } from '@core/enums/civility.enum';

export interface ContactInfo {
  clientType: Typology | null;
  clientNumber: string;
  civility: Civility | null;
  lastName: string;
  firstName: string;
  countryCode: string;
  phoneNumber: string;
  email: string;
}

export const EMPTY_CONTACT_INFO: ContactInfo = {
  clientType: null,
  clientNumber: '',
  civility: null,
  lastName: '',
  firstName: '',
  countryCode: '1',
  phoneNumber: '',
  email: '',
};
